import { useTranslation } from "react-i18next";
import Option from "../OtherOptions/Option";

function GpsGeofence({ disabled }) {
	const { t } = useTranslation();

	return (
		<div className="border-bottom mb-5">
			<h3 className="text-sm font-weight-bolder mt-3">{t("gps-geofence")}</h3>

			<Option
				title={t("enable-gps-location")}
				name="gpsLocation"
				disabled={disabled}
			/>

			<Option
				title={t("enable-clockin-without-geofence")}
				name="clockinWithoutGeofence"
				disabled={disabled}
			/>

			<Option
				title={t("require-geofence-shift-start")}
				name="geofenceLocation"
				disabled={disabled}
			/>

			<Option
				title={t("require-geofence-break-start")}
				name="startBreakGeofenceLocation"
				disabled={disabled}
			/>

			<Option
				title={t("require-geofence-break-end")}
				name="endBreakGeofenceLocation"
				disabled={disabled}
			/>

			<Option
				title={t("require-geofence-shift-end")}
				name="endShiftGeofenceLocation"
				disabled={disabled}
			/>
		</div>
	);
}

export default GpsGeofence;
